import React from 'react';
import { Award, Users, Clock, Shield } from 'lucide-react';

const AboutSection = () => {
  const stats = [
    { icon: Award, label: 'Years Experience', value: '25+', color: '#8B1818' },
    { icon: Users, label: 'Projects Completed', value: '500+', color: '#000080' },
    { icon: Clock, label: '24/7 Support', value: 'Available', color: '#6B7280' },
    { icon: Shield, label: 'Certified Professionals', value: '100%', color: '#8B1818' },
  ];

  return (
    <section id="about" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">About iXus Group Limited</h2>
          <div className="w-24 h-1 bg-[#8B1818] mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-gray-900">Your Trusted Partner in Building Solutions</h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              With over two decades of excellence, iXus Group Limited has established itself as a leading provider 
              of comprehensive building solutions. Our commitment to quality, innovation, and customer satisfaction 
              sets us apart in the industry.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              We specialize in three core sectors: HVAC systems, electrical services, and door automation. 
              Our team of certified professionals brings expertise and dedication to every project, ensuring 
              exceptional results that exceed expectations.
            </p>
            <div className="flex gap-4 pt-4">
              <div className="w-2 bg-[#8B1818]"></div>
              <p className="text-gray-600 italic">
                "Excellence is not just our goal—it's our standard. We deliver solutions that stand the test of time."
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6">
            {stats.map((stat, idx) => {
              const Icon = stat.icon;
              return (
                <div
                  key={idx}
                  className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
                >
                  <Icon size={40} style={{ color: stat.color }} className="mb-4" />
                  <div className="text-3xl font-bold text-gray-900 mb-2">{stat.value}</div>
                  <div className="text-gray-600 font-medium">{stat.label}</div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Core Values */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">Our Core Values</h3>
          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 bg-[#8B1818] rounded-full"></div>
              </div>
              <h4 className="font-bold text-lg text-gray-900 mb-2">Quality</h4>
              <p className="text-gray-600">Uncompromising standards in every project</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 bg-[#000080] rounded-full"></div>
              </div>
              <h4 className="font-bold text-lg text-gray-900 mb-2">Innovation</h4>
              <p className="text-gray-600">Embracing latest technologies and methods</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 bg-gray-600 rounded-full"></div>
              </div>
              <h4 className="font-bold text-lg text-gray-900 mb-2">Reliability</h4>
              <p className="text-gray-600">Dependable service you can count on</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 bg-[#8B1818] rounded-full"></div>
              </div>
              <h4 className="font-bold text-lg text-gray-900 mb-2">Safety</h4>
              <p className="text-gray-600">Prioritizing safety in all operations</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;